/**
 * CustomerCheckoutWakeScreen — Order review / wake screen
 * Smooth transition from idle showing order summary
 */
import React from 'react';

export default function CustomerCheckoutWakeScreen({ checkout, onContinue }) {
  const items = checkout?.items || [];
  const subtotal = checkout?.subtotal || 0;
  const tax = checkout?.tax || 0;
  const total = subtotal + tax;
  const fmt = (n) => `$${Number(n).toFixed(2)}`;

  return (
    <div className="cfd-panel cfd-slide-up" data-testid="order-review-screen">
      <h2 className="cfd-heading">Your Order</h2>

      <div className="cfd-items-list">
        {items.map((it, i) => (
          <div
            key={i}
            className="cfd-item-row"
            style={{ animationDelay: `${i * 60}ms` }}
            data-testid={`order-item-${i}`}
          >
            <div className="cfd-item-left">
              <span className="cfd-item-qty">{it.qty || it.quantity || 1}x</span>
              <span className="cfd-item-name">{it.name}</span>
            </div>
            <span className="cfd-item-price">{fmt((it.price || 0) * (it.qty || it.quantity || 1))}</span>
          </div>
        ))}
      </div>

      <div className="cfd-summary-box">
        <div className="cfd-summary-row"><span>Subtotal</span><span>{fmt(subtotal)}</span></div>
        <div className="cfd-summary-row"><span>Tax</span><span>{fmt(tax)}</span></div>
        <div className="cfd-summary-total">
          <span>Total</span><span>{fmt(total)}</span>
        </div>
      </div>

      <button onClick={onContinue} className="cfd-btn-primary" data-testid="continue-to-tip-btn">
        Continue
      </button>
    </div>
  );
}
